import { createSlice } from "@reduxjs/toolkit";

//Todo => Custom roles created by the main vendor
const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    customRoles: [],
    
    //* Available system permissions (from API or fallback)
    systemPermissions: {},
    
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    
    //* Error states
    error: null,
    createError: null,
    updateError: null,
    deleteError: null,    
    selectedRole: null,
    isEditingRole: false,
    roleFormData: null,
  },
  reducers: {
    //* Loading states
    setLoading: (state, action) => {
      state.isLoading = action.payload;
      if (action.payload) state.error = null;
    },
    setCreating: (state, action) => {
      state.isCreating = action.payload;
      if (action.payload) state.createError = null;
    },
    setUpdating: (state, action) => {
      state.isUpdating = action.payload;
      if (action.payload) state.updateError = null;
    },
    setDeleting: (state, action) => {
      state.isDeleting = action.payload;
      if (action.payload) state.deleteError = null;
    },

    //* Error states
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setCreateError: (state, action) => {
      state.createError = action.payload;
      state.isCreating = false;
    },
    setUpdateError: (state, action) => {
      state.updateError = action.payload;
      state.isUpdating = false;
    },
    setDeleteError: (state, action) => {
      state.deleteError = action.payload;
      state.isDeleting = false;
    },

    //* System permissions
    setSystemPermissions: (state, action) => {
      state.systemPermissions = action.payload;
    },

    //* Custom roles management
    setCustomRoles: (state, action) => {
      state.customRoles = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    addCustomRole: (state, action) => {
      state.customRoles.push(action.payload);
      state.isCreating = false;
      state.createError = null;
      state.roleFormData = null;
    },

    updateCustomRole: (state, action) => {
      const { role_slug, ...updatedData } = action.payload;
      const index = state.customRoles.findIndex(role => role.role_slug === role_slug);
      
      if (index !== -1) {
        state.customRoles[index] = { ...state.customRoles[index], ...updatedData };
      }
      
      state.isUpdating = false;
      state.updateError = null;
      state.isEditingRole = false;
      state.selectedRole = null;
      state.roleFormData = null;
    },

    removeCustomRole: (state, action) => {
      const roleSlug = action.payload;
      state.customRoles = state.customRoles.filter(role => role.role_slug !== roleSlug);
      state.isDeleting = false;
      state.deleteError = null;
      state.selectedRole = null;
    },

    // UI state management
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },

    setIsEditingRole: (state, action) => {
      state.isEditingRole = action.payload;
      if (!action.payload) {
        state.selectedRole = null;
        state.roleFormData = null;
      }
    },

    setRoleFormData: (state, action) => {
      state.roleFormData = action.payload;
    },

    //* Helper to check if role can be deleted (not used by any team member)
    canDeleteRole: (state, action) => {
      const { roleSlug, teamMembers } = action.payload;
      const role = state.customRoles.find(r => r.role_slug === roleSlug);
      if (!role) return false;
      
      return !teamMembers.some(member => member.role === role.name);
    },

    //* Reset all states
    resetRolesState: (state) => {
      state.selectedRole = null;
      state.isEditingRole = false;
      state.roleFormData = null;
      state.error = null;
      state.createError = null;
      state.updateError = null;
      state.deleteError = null;
    },

    //* Complete reset for logout
    reset: (state) => {
      state.customRoles = [];
      state.systemPermissions = {};
      state.isLoading = false;
      state.isCreating = false;
      state.isUpdating = false;
      state.isDeleting = false;
      state.error = null;
      state.createError = null;
      state.updateError = null;
      state.deleteError = null;
      state.selectedRole = null;
      state.isEditingRole = false;
      state.roleFormData = null;
    }
  }
});

export const {
  setLoading,
  setCreating,
  setUpdating,
  setDeleting,
  setError,
  setCreateError,
  setUpdateError,
  setDeleteError,
  setSystemPermissions,
  setCustomRoles,
  addCustomRole,
  updateCustomRole,
  removeCustomRole,
  setSelectedRole,
  setIsEditingRole,
  setRoleFormData,
  canDeleteRole,
  resetRolesState,
  reset
} = rolesSlice.actions;

export default rolesSlice.reducer; 